<div class="leave-application-details-view-container"  fxLayout="column" fxLayoutGap="15px" *ngIf="leaveApplication" >
  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + leaveApplication.status?.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="leaveApplication.status?.name">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
<!--    <button-->
<!--      mat-stroked-button (click)="addLeaveApplication()"-->
<!--    ><mat-icon>create</mat-icon><span> Dodaj wniosek</span></button>-->
    <button
      [disabled]="!(userPermissions | async).human_resources?.admin_root"
      *ngIf="leaveApplication.status?.key === LEAVE_APPLICATION_STATUS_FOR_ACCEPTANCE "
      mat-stroked-button
      (click)="accept()"
    ><span>Zaakceptuj</span></button>

    <button
      [disabled]="!(userPermissions | async).human_resources?.admin_root"
      *ngIf="leaveApplication.status?.key === LEAVE_APPLICATION_STATUS_FOR_ACCEPTANCE || leaveApplication.status?.key === LEAVE_APPLICATION_STATUS_ACCEPTED"
      mat-stroked-button
      (click)="cancel()"
    ><span>Anuluj</span></button>

    <button
      [disabled]="!(userPermissions | async).human_resources?.admin_root"
      *ngIf="leaveApplication.status?.key === LEAVE_APPLICATION_STATUS_FOR_ACCEPTANCE"
      mat-stroked-button
      (click)="reject()"
    ><span>Odrzuć</span></button>

    <button
      [disabled]="!(userPermissions | async).human_resources?.admin_root"
      *ngIf="leaveApplication.status?.key !== LEAVE_APPLICATION_STATUS_FOR_ACCEPTANCE"
      mat-stroked-button
      (click)="forAcceptance()"
    ><span>Do akceptacji</span></button>

    <button
      [disabled]="!(userPermissions | async).human_resources?.admin_root"
      *ngIf="leaveApplication.fileName"
      mat-stroked-button
      (click)="downloadDocument()"
    ><span>Pobierz dokument</span></button>

    <button
      [disabled]="!(userPermissions | async).human_resources?.admin_root "
      *ngIf="leaveApplication.type?.key === LEAVE_APPLICATION_TYPE_OCCASIONAL_LEAVE"
      mat-stroked-button
      (click)="addFile()"
    ><span>Dodaj dokument</span></button>

    <button *ngIf="leaveApplication.status?.key === LEAVE_APPLICATION_STATUS_FOR_ACCEPTANCE"
            [disabled]="!(userPermissions | async).human_resources.admin_root  "
            (click)="modify()" mat-stroked-button color="primary">
      <mat-icon>edit</mat-icon> <span> Edytuj</span></button>


    <button
      mat-stroked-button
      [style.visibility]="'hidden'"
    ><span>edit</span></button>

  </div>

  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px" style=" top: 55px;">
    <div fxLayout="column" fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card >
            <div fxLayout="row">
              <h3>Dane  </h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Rodzaj wniosku" [value]="leaveApplication.type.name"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Data od" [value]="(leaveApplication.startDate | date:'y-MM-dd' )+ ' ' +( leaveApplication.startAt ? leaveApplication.startAt :'')"></app-detail>
              </div>
              <div fxFlex="50">
                <app-detail header="Data do" [value]="leaveApplication.endDate | date:'y-MM-dd'  + ' ' + (leaveApplication.endAt ? leaveApplication.endAt : '') "></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="25">
                <app-detail header="Wymiar urlopu	" [value]=" leaveApplication.minuteDimension? 'Godzina' :  (leaveApplication.time? '1/2 dnia' : 'Pełny dzień' )"></app-detail>
              </div>
              <div fxFlex="25">
                <app-detail header="Liczba dni urlopu	" [value]=" leaveApplication.time? '-' : leaveApplication.day.toString()"></app-detail>
              </div>
              <div fxFlex="25">
                <app-detail header="Wymiar godzin	" [value]="leaveApplication.time? leaveApplication.time.name : '-' "></app-detail>
              </div>
              <div fxFlex="25">
                <app-detail header="Ilość godzin 	" [value]="leaveApplication.minuteDimension? formatMinutesToHours(leaveApplication.minuteDimension) : '-' "></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Uwagi " [value]="leaveApplication.note"></app-detail>
              </div>



            </div>



          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>
